import { render, staticRenderFns } from "./BlocoInserirViaPlanilhaCertificacao.vue?vue&type=template&id=1d57cb57&scoped=true&lang=pug"
import script from "./BlocoInserirViaPlanilhaCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoInserirViaPlanilhaCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInserirViaPlanilhaCertificacao.vue?vue&type=style&index=0&id=1d57cb57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57cb57",
  null
  
)

export default component.exports